import * as React from "react";

const SvgArrowLeft = (props) => (
  <svg
    width={26}
    height={49}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.7 48.997c.332 0 .665-.126.92-.376a1.283 1.283 0 0 0 0-1.824L3.139 24.5l22.48-22.298a1.283 1.283 0 0 0 0-1.824 1.309 1.309 0 0 0-1.838 0L.381 23.59a1.283 1.283 0 0 0 0 1.823l23.4 23.212a1.3 1.3 0 0 0 .92.376l-.002-.003Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowLeft;
